export const allStates = [
  // United States
  { name: 'Alabama', value: 'Alabama' },
  { name: 'Alaska', value: 'Alaska' },
  { name: 'Arizona', value: 'Arizona' },
  { name: 'Arkansas', value: 'Arkansas' },
  { name: 'California', value: 'California' },
  { name: 'Colorado', value: 'Colorado' },
  { name: 'Connecticut', value: 'Connecticut' },
  { name: 'Delaware', value: 'Delaware' },
  { name: 'Florida', value: 'Florida' },
  { name: 'Georgia', value: 'Georgia' },
  { name: 'Hawaii', value: 'Hawaii' },
  { name: 'Idaho', value: 'Idaho' },
  { name: 'Illinois', value: 'Illinois' },
  { name: 'Indiana', value: 'Indiana' },
  { name: 'Iowa', value: 'Iowa' },
  { name: 'Kansas', value: 'Kansas' },
  { name: 'Kentucky', value: 'Kentucky' },
  { name: 'Louisiana', value: 'Louisiana' },
  { name: 'Maine', value: 'Maine' },
  { name: 'Maryland', value: 'Maryland' },
  { name: 'Massachusetts', value: 'Massachusetts' },
  { name: 'Michigan', value: 'Michigan' },
  { name: 'Minnesota', value: 'Minnesota' },
  { name: 'Mississippi', value: 'Mississippi' },
  { name: 'Missouri', value: 'Missouri' },
  { name: 'Montana', value: 'Montana' },
  { name: 'Nebraska', value: 'Nebraska' },
  { name: 'Nevada', value: 'Nevada' },
  { name: 'New Hampshire', value: 'New Hampshire' },
  { name: 'New Jersey', value: 'New Jersey' },
  { name: 'New Mexico', value: 'New Mexico' },
  { name: 'New York', value: 'New York' },
  { name: 'North Carolina', value: 'North Carolina' },
  { name: 'North Dakota', value: 'North Dakota' },
  { name: 'Ohio', value: 'Ohio' },
  { name: 'Oklahoma', value: 'Oklahoma' },
  { name: 'Oregon', value: 'Oregon' },
  { name: 'Pennsylvania', value: 'Pennsylvania' },
  { name: 'Rhode Island', value: 'Rhode Island' },
  { name: 'South Carolina', value: 'South Carolina' },
  { name: 'South Dakota', value: 'South Dakota' },
  { name: 'Tennessee', value: 'Tennessee' },
  { name: 'Texas', value: 'Texas' },
  { name: 'Utah', value: 'Utah' },
  { name: 'Vermont', value: 'Vermont' },
  { name: 'Virginia', value: 'Virginia' },
  { name: 'Washington', value: 'Washington' },
  { name: 'West Virginia', value: 'West Virginia' },
  { name: 'Wisconsin', value: 'Wisconsin' },
  { name: 'Wyoming', value: 'Wyoming' },

  // Australia
  { name: 'New South Wales', value: 'New South Wales' },
  { name: 'Queensland', value: 'Queensland' },
  { name: 'South Australia', value: 'South Australia' },
  { name: 'Tasmania', value: 'Tasmania' },
  { name: 'Victoria', value: 'Victoria' },
  { name: 'Western Australia', value: 'Western Australia' },
  { name: 'Australian Capital Territory', value: 'Australian Capital Territory' },
  { name: 'Northern Territory', value: 'Northern Territory' },

  // Canada
  { name: 'Alberta', value: 'Alberta' },
  { name: 'British Columbia', value: 'British Columbia' },
  { name: 'Manitoba', value: 'Manitoba' },
  { name: 'New Brunswick', value: 'New Brunswick' },
  { name: 'Newfoundland and Labrador', value: 'Newfoundland and Labrador' },
  { name: 'Nova Scotia', value: 'Nova Scotia' },
  { name: 'Ontario', value: 'Ontario' },
  { name: 'Prince Edward Island', value: 'Prince Edward Island' },
  { name: 'Quebec', value: 'Quebec' },
  { name: 'Saskatchewan', value: 'Saskatchewan' },
  { name: 'Northwest Territories', value: 'Northwest Territories' },
  { name: 'Nunavut', value: 'Nunavut' },
  { name: 'Yukon', value: 'Yukon' },

  // Mexico
  { name: 'Aguascalientes', value: 'Aguascalientes' },
  { name: 'Baja California', value: 'Baja California' },
  { name: 'Baja California Sur', value: 'Baja California Sur' },
  { name: 'Campeche', value: 'Campeche' },
  { name: 'Chiapas', value: 'Chiapas' },
  { name: 'Chihuahua', value: 'Chihuahua' },
  { name: 'Coahuila', value: 'Coahuila' },
  { name: 'Colima', value: 'Colima' },
  { name: 'Durango', value: 'Durango' },
  { name: 'Guanajuato', value: 'Guanajuato' },
  { name: 'Guerrero', value: 'Guerrero' },
  { name: 'Hidalgo', value: 'Hidalgo' },
  { name: 'Jalisco', value: 'Jalisco' },
  { name: 'Mexico City', value: 'Mexico City' },
  { name: 'México', value: 'México' },
  { name: 'Michoacán', value: 'Michoacán' },
  { name: 'Morelos', value: 'Morelos' },
  { name: 'Nayarit', value: 'Nayarit' },
  { name: 'Nuevo León', value: 'Nuevo León' },
  { name: 'Oaxaca', value: 'Oaxaca' },
  { name: 'Puebla', value: 'Puebla' },
  { name: 'Querétaro', value: 'Querétaro' },
  { name: 'Quintana Roo', value: 'Quintana Roo' },
  { name: 'San Luis Potosí', value: 'San Luis Potosí' },
  { name: 'Sinaloa', value: 'Sinaloa' },
  { name: 'Sonora', value: 'Sonora' },
  { name: 'Tabasco', value: 'Tabasco' },
  { name: 'Tamaulipas', value: 'Tamaulipas' },
  { name: 'Tlaxcala', value: 'Tlaxcala' },
  { name: 'Veracruz', value: 'Veracruz' },
  { name: 'Yucatán', value: 'Yucatán' },
  { name: 'Zacatecas', value: 'Zacatecas' },

  // Pakistan
  { name: 'Balochistan', value: 'Balochistan' },
  { name: 'Khyber Pakhtunkhwa', value: 'Khyber Pakhtunkhwa' },
  { name: 'Punjab', value: 'Punjab' },
  { name: 'Sindh', value: 'Sindh' },
  { name: 'Azad Jammu and Kashmir', value: 'Azad Jammu and Kashmir' },
  { name: 'Gilgit-Baltistan', value: 'Gilgit-Baltistan' },
  { name: 'Islamabad Capital Territory', value: 'Islamabad Capital Territory' },

  // Liberia
  { name: 'Bomi', value: 'Bomi' },
  { name: 'Bong', value: 'Bong' },
  { name: 'Gbarpolu', value: 'Gbarpolu' },
  { name: 'Grand Bassa', value: 'Grand Bassa' },
  { name: 'Grand Cape Mount', value: 'Grand Cape Mount' },
  { name: 'Grand Gedeh', value: 'Grand Gedeh' },
  { name: 'Grand Kru', value: 'Grand Kru' },
  { name: 'Lofa', value: 'Lofa' },
  { name: 'Margibi', value: 'Margibi' },
  { name: 'Maryland', value: 'Maryland' },
  { name: 'Montserrado', value: 'Montserrado' },
  { name: 'Nimba', value: 'Nimba' },
  { name: 'River Gee', value: 'River Gee' },
  { name: 'Rivercess', value: 'Rivercess' },
  { name: 'Sinoe', value: 'Sinoe' },
];

// export const staticStates = [
//   {
//     country: 'United States of America',
//     states: [
//       { name: 'Alabama', value: 'Alabama' },
//       { name: 'Alaska', value: 'Alaska' },
//       { name: 'Arizona', value: 'Arizona' },
//       { name: 'Arkansas', value: 'Arkansas' },
//       { name: 'California', value: 'California' },
//       { name: 'Colorado', value: 'Colorado' },
//       { name: 'Connecticut', value: 'Connecticut' },
//       { name: 'Delaware', value: 'Delaware' },
//       { name: 'Florida', value: 'Florida' },
//       { name: 'Georgia', value: 'Georgia' },
//       { name: 'Hawaii', value: 'Hawaii' },
//       { name: 'Idaho', value: 'Idaho' },
//       { name: 'Illinois', value: 'Illinois' },
//       { name: 'Indiana', value: 'Indiana' },
//       { name: 'Iowa', value: 'Iowa' },
//       { name: 'Kansas', value: 'Kansas' },
//       { name: 'Kentucky', value: 'Kentucky' },
//       { name: 'Louisiana', value: 'Louisiana' },
//       { name: 'Maine', value: 'Maine' },
//       { name: 'Maryland', value: 'Maryland' },
//       { name: 'Massachusetts', value: 'Massachusetts' },
//       { name: 'Michigan', value: 'Michigan' },
//       { name: 'Minnesota', value: 'Minnesota' },
//       { name: 'Mississippi', value: 'Mississippi' },
//       { name: 'Missouri', value: 'Missouri' },
//       { name: 'Montana', value: 'Montana' },
//       { name: 'Nebraska', value: 'Nebraska' },
//       { name: 'Nevada', value: 'Nevada' },
//       { name: 'New Hampshire', value: 'New Hampshire' },
//       { name: 'New Jersey', value: 'New Jersey' },
//       { name: 'New Mexico', value: 'New Mexico' },
//       { name: 'New York', value: 'New York' },
//       { name: 'North Carolina', value: 'North Carolina' },
//       { name: 'North Dakota', value: 'North Dakota' },
//       { name: 'Ohio', value: 'Ohio' },
//       { name: 'Oklahoma', value: 'Oklahoma' },
//       { name: 'Oregon', value: 'Oregon' },
//       { name: 'Pennsylvania', value: 'Pennsylvania' },
//       { name: 'Rhode Island', value: 'Rhode Island' },
//       { name: 'South Carolina', value: 'South Carolina' },
//       { name: 'South Dakota', value: 'South Dakota' },
//       { name: 'Tennessee', value: 'Tennessee' },
//       { name: 'Texas', value: 'Texas' },
//       { name: 'Utah', value: 'Utah' },
//       { name: 'Vermont', value: 'Vermont' },
//       { name: 'Virginia', value: 'Virginia' },
//       { name: 'Washington', value: 'Washington' },
//       { name: 'West Virginia', value: 'West Virginia' },
//       { name: 'Wisconsin', value: 'Wisconsin' },
//       { name: 'Wyoming', value: 'Wyoming' },
//     ],
//   },
//   {
//     country: 'The former Yugoslav Republic of Macedonia',
//     states: [
//       { name: 'Aerodrom', value: 'Aerodrom' },
//       { name: 'Aračinovo', value: 'Aračinovo' },
//       { name: 'Berovo', value: 'Berovo' },
//       { name: 'Bitola', value: 'Bitola' },
//       { name: 'Bogdanci', value: 'Bogdanci' },
//       { name: 'Bogovinje', value: 'Bogovinje' },
//       { name: 'Bosilovo', value: 'Bosilovo' },
//       { name: 'Brvenica', value: 'Brvenica' },
//       { name: 'Butel', value: 'Butel' },
//       { name: 'Centar', value: 'Centar' },
//       { name: 'Centar Župa', value: 'Centar Župa' },
//       { name: 'Čair', value: 'Čair' },
//       { name: 'Čaška', value: 'Čaška' },
//       { name: 'Češinovo-Obleševo', value: 'Češinovo-Obleševo' },
//       { name: 'Čučer-Sandevo', value: 'Čučer-Sandevo' },
//       { name: 'Debar', value: 'Debar' },
//       { name: 'Debarca', value: 'Debarca' },
//       { name: 'Delčevo', value: 'Delčevo' },
//       { name: 'Demir Hisar', value: 'Demir Hisar' },
//       { name: 'Demir Kapija', value: 'Demir Kapija' },
//       { name: 'Dojran', value: 'Dojran' },
//       { name: 'Dolneni', value: 'Dolneni' },
//       { name: 'Gazi Baba', value: 'Gazi Baba' },
//       { name: 'Gevgelija', value: 'Gevgelija' },
//       { name: 'Gjorče Petrov', value: 'Gjorče Petrov' },
//       { name: 'Gostivar', value: 'Gostivar' },
//       { name: 'Gradsko', value: 'Gradsko' },
//       { name: 'Ilinden', value: 'Ilinden' },
//       { name: 'Jegunovce', value: 'Jegunovce' },
//       { name: 'Karbinci', value: 'Karbinci' },
//       { name: 'Karpoš', value: 'Karpoš' },
//       { name: 'Kavadarci', value: 'Kavadarci' },
//       { name: 'Kičevo', value: 'Kičevo' },
//       { name: 'Kisela Voda', value: 'Kisela Voda' },
//       { name: 'Kočani', value: 'Kočani' },
//       { name: 'Konče', value: 'Konče' },
//       { name: 'Kratovo', value: 'Kratovo' },
//       { name: 'Kriva Palanka', value: 'Kriva Palanka' },
//       { name: 'Krivogaštani', value: 'Krivogaštani' },
//       { name: 'Kruševo', value: 'Kruševo' },
//       { name: 'Kumanovo', value: 'Kumanovo' },
//       { name: 'Lipkovo', value: 'Lipkovo' },
//       { name: 'Lozovo', value: 'Lozovo' },
//       { name: 'Makedonska Kamenica', value: 'Makedonska Kamenica' },
//       { name: 'Makedonski Brod', value: 'Makedonski Brod' },
//       { name: 'Mavrovo and Rostuša', value: 'Mavrovo and Rostuša' },
//       { name: 'Mogila', value: 'Mogila' },
//       { name: 'Negotino', value: 'Negotino' },
//       { name: 'Novaci', value: 'Novaci' },
//       { name: 'Novo Selo', value: 'Novo Selo' },
//       { name: 'Ohrid', value: 'Ohrid' },
//       { name: 'Petrovec', value: 'Petrovec' },
//       { name: 'Pehčevo', value: 'Pehčevo' },
//       { name: 'Plasnica', value: 'Plasnica' },
//       { name: 'Prilep', value: 'Prilep' },
//       { name: 'Probištip', value: 'Probištip' },
//       { name: 'Radoviš', value: 'Radoviš' },
//       { name: 'Rankovce', value: 'Rankovce' },
//       { name: 'Resen', value: 'Resen' },
//       { name: 'Rosoman', value: 'Rosoman' },
//       { name: 'Saraj', value: 'Saraj' },
//       { name: 'Sopište', value: 'Sopište' },
//       { name: 'Staro Nagoričane', value: 'Staro Nagoričane' },
//       { name: 'Struga', value: 'Struga' },
//       { name: 'Strumica', value: 'Strumica' },
//       { name: 'Studeničani', value: 'Studeničani' },
//       { name: 'Štip', value: 'Štip' },
//       { name: 'Sveti Nikole', value: 'Sveti Nikole' },
//       { name: 'Tearce', value: 'Tearce' },
//       { name: 'Tetovo', value: 'Tetovo' },
//       { name: 'Valandovo', value: 'Valandovo' },
//       { name: 'Vasilevo', value: 'Vasilevo' },
//       { name: 'Veles', value: 'Veles' },
//       { name: 'Vevčani', value: 'Vevčani' },
//       { name: 'Vinica', value: 'Vinica' },
//       { name: 'Vrapčište', value: 'Vrapčište' },
//       { name: 'Zelenikovo', value: 'Zelenikovo' },
//       { name: 'Želino', value: 'Želino' },
//       { name: 'Zrnovci', value: 'Zrnovci' },
//     ],
//   },
//   {
//     country: 'Pakistan',
//     states: [
//       { name: 'Balochistan', value: 'Balochistan' },
//       { name: 'Khyber Pakhtunkhwa', value: 'Khyber Pakhtunkhwa' },
//       { name: 'Punjab', value: 'Punjab' },
//       { name: 'Sindh', value: 'Sindh' },
//       { name: 'Azad Jammu and Kashmir', value: 'Azad Jammu and Kashmir' },
//       { name: 'Gilgit-Baltistan', value: 'Gilgit-Baltistan' },
//       { name: 'Islamabad Capital Territory', value: 'Islamabad Capital Territory' },
//     ],
//   },

//   {
//     country: 'Australia',
//     states: [
//       { name: 'New South Wales', value: 'New South Wales' },
//       { name: 'Queensland', value: 'Queensland' },
//       { name: 'South Australia', value: 'South Australia' },
//       { name: 'Tasmania', value: 'Tasmania' },
//       { name: 'Victoria', value: 'Victoria' },
//       { name: 'Western Australia', value: 'Western Australia' },
//       { name: 'Australian Capital Territory', value: 'Australian Capital Territory' },
//       { name: 'Northern Territory', value: 'Northern Territory' },
//     ],
//   },
//   {
//     country: 'Mexico',
//     states: [
//       { name: 'Aguascalientes', value: 'Aguascalientes' },
//       { name: 'Baja California', value: 'Baja California' },
//       { name: 'Baja California Sur', value: 'Baja California Sur' },
//       { name: 'Campeche', value: 'Campeche' },
//       { name: 'Chiapas', value: 'Chiapas' },
//       { name: 'Chihuahua', value: 'Chihuahua' },
//       { name: 'Coahuila', value: 'Coahuila' },
//       { name: 'Colima', value: 'Colima' },
//       { name: 'Durango', value: 'Durango' },
//       { name: 'Guanajuato', value: 'Guanajuato' },
//       { name: 'Guerrero', value: 'Guerrero' },
//       { name: 'Hidalgo', value: 'Hidalgo' },
//       { name: 'Jalisco', value: 'Jalisco' },
//       { name: 'Mexico City', value: 'Mexico City' },
//       { name: 'México', value: 'México' },
//       { name: 'Michoacán', value: 'Michoacán' },
//       { name: 'Morelos', value: 'Morelos' },
//       { name: 'Nayarit', value: 'Nayarit' },
//       { name: 'Nuevo León', value: 'Nuevo León' },
//       { name: 'Oaxaca', value: 'Oaxaca' },
//       { name: 'Puebla', value: 'Puebla' },
//       { name: 'Querétaro', value: 'Querétaro' },
//       { name: 'Quintana Roo', value: 'Quintana Roo' },
//       { name: 'San Luis Potosí', value: 'San Luis Potosí' },
//       { name: 'Sinaloa', value: 'Sinaloa' },
//       { name: 'Sonora', value: 'Sonora' },
//       { name: 'Tabasco', value: 'Tabasco' },
//       { name: 'Tamaulipas', value: 'Tamaulipas' },
//       { name: 'Tlaxcala', value: 'Tlaxcala' },
//       { name: 'Veracruz', value: 'Veracruz' },
//       { name: 'Yucatán', value: 'Yucatán' },
//       { name: 'Zacatecas', value: 'Zacatecas' },
//     ],
//   },
//   {
//     country: 'Liberia',
//     states: [
//       { name: 'Bomi', value: 'Bomi' },
//       { name: 'Bong', value: 'Bong' },
//       { name: 'Gbarpolu', value: 'Gbarpolu' },
//       { name: 'Grand Bassa', value: 'Grand Bassa' },
//       { name: 'Grand Cape Mount', value: 'Grand Cape Mount' },
//       { name: 'Grand Gedeh', value: 'Grand Gedeh' },
//       { name: 'Grand Kru', value: 'Grand Kru' },
//       { name: 'Lofa', value: 'Lofa' },
//       { name: 'Margibi', value: 'Margibi' },
//       { name: 'Maryland', value: 'Maryland' },
//       { name: 'Montserrado', value: 'Montserrado' },
//       { name: 'Nimba', value: 'Nimba' },
//       { name: 'River Gee', value: 'River Gee' },
//       { name: 'Rivercess', value: 'Rivercess' },
//       { name: 'Sinoe', value: 'Sinoe' },
//     ],
//   },
//   {
//     country: 'Canada',
//     states: [
//       { name: 'Alberta', value: 'Alberta' },
//       { name: 'British Columbia', value: 'British Columbia' },
//       { name: 'Manitoba', value: 'Manitoba' },
//       { name: 'New Brunswick', value: 'New Brunswick' },
//       { name: 'Newfoundland and Labrador', value: 'Newfoundland and Labrador' },
//       { name: 'Nova Scotia', value: 'Nova Scotia' },
//       { name: 'Ontario', value: 'Ontario' },
//       { name: 'Prince Edward Island', value: 'Prince Edward Island' },
//       { name: 'Quebec', value: 'Quebec' },
//       { name: 'Saskatchewan', value: 'Saskatchewan' },
//       { name: 'Northwest Territories', value: 'Northwest Territories' },
//       { name: 'Nunavut', value: 'Nunavut' },
//       { name: 'Yukon', value: 'Yukon' },
//     ],
//   },
// ];
